import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { showModal } from '../actions';

const TermsModalHandler = ({
  dispatch, profile, share, uploadPage,
}) => {
  useEffect(() => {
    if (profile && (profile.uuid || share || uploadPage)) {
      if (
        profile.needs_accept_terms ||
        (share && share.require_accept_document) ||
        (uploadPage && uploadPage.require_accept_document_action)
      ) {
        dispatch(showModal('TermsModal', {
          className: 'modal-terms modal-xl',
          share,
          uploadPage,
        }));
      }
    }
  }, [dispatch, profile, share, uploadPage]);

  return null;
};

const mapStateToProps = state => ({
  profile: state.Auth.profile,
});

TermsModalHandler.propTypes = {
  dispatch: PropTypes.func.isRequired,
  profile: PropTypes.object,
  share: PropTypes.object,
  uploadPage: PropTypes.object,
};

TermsModalHandler.defaultProps = {
  profile: null,
  share: null,
  uploadPage: null,
};

export default connect(mapStateToProps)(TermsModalHandler);
